import { Injectable } from '@angular/core';
import { Baseproperties } from '../../utility/baseproperties';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SupportserviceService {
  baseproperties: Baseproperties = new Baseproperties(); 

    private baseURL = this.baseproperties.gatewayBaseURL+"/common"
  constructor(private httpClient: HttpClient) { }
     getorglist(): Observable<any> {
          return this.httpClient.get(`${this.baseURL}/support/getorglist`);
        }
        // getlogininformation
          getlogininformation(loginid): Observable<any> {
          return this.httpClient.post(`${this.baseURL}/support/getlogininformation`,loginid);
        }
   logininassupport(payload): Observable<any> {
          return this.httpClient.post(`${this.baseURL}/api/supportlogin`,payload);
        }
       traininglink(): Observable<any> {
        return this.httpClient.get(this.baseURL + "/api/traininglink");
    }

       trainingemaillink(data): Observable<any> {
        return this.httpClient.post(this.baseURL + "/api/sendtraininginvite",data);
    }
}
